import { useNavigate } from "react-router-dom";
import { useCustomDispatch } from "../../hooks";
import * as storage from "../../state/storage";

export default function Me() {
  const labels: string[] = JSON.parse(localStorage.getItem("labels") ?? "[]");

  const dispatch = useCustomDispatch();

  const navigate = useNavigate();

  const handleClick = (label: string) => {
    if (!labels.includes(label)) return;
    dispatch(storage.actions.load(label));
    localStorage.setItem("label", label);
    navigate("/");
  };

  return (
    <>
      <ul className="mx-6 flex gap-2 flex-col">
        {labels.map((label) => (
          <li
            onClick={() => handleClick(label)}
            key={label}
            className="px-2 py-3 border border-black rounded-md cursor-pointer"
          >
            <span>{label}</span>
          </li>
        ))}
      </ul>
    </>
  );
}
